/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Extended error class with status code and details.
 * @export
 * @class ErrorWithHttpStatusCode
 * @extends {Error}
 */
export class ErrorWithHttpStatusCode extends Error {
  constructor(
    public statusCode: number,
    public message: string,
    public details: string,
  ) {
    super(message);
  }
}
